import { VehicleModel } from '../../app-lite/vehicles/models/vehicle';

export class VehicleTransactionCtrl implements ng.IComponentController {
  public onDelete: Function;
  public onPrint : Function;
  public vehicle : VehicleModel;
}
